import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type useGofacReRunMutationProps = {
	id: number;
	onSuccessHandler?: Function;
};

const useGofacReRunMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id }: useGofacReRunMutationProps) =>
			autoChecklistService.reRunGOFAC(id),
		{
			onSuccess(_, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "gOFAC re-run was successful",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useGofacReRunMutation;
